//src/pages/landing/BookDemoModal.jsx
import React, { useState, useRef, useEffect, useCallback } from "react";
import { FaCheck } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { sendLiveDemoEmail } from "../../api/admin/adminApi.js";

const BookDemoModal = ({ onClose }) => {
  const initialState = { name: "", email: "", date: "", time: "" };
  const [formData, setFormData]   = useState(initialState);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const dialogRef   = useRef(null); 
  const firstField  = useRef(null);

  const escListener = useCallback(
    (e) => e.key === "Escape" && onClose(),
    [onClose]
  );

  useEffect(() => {
    document.addEventListener("keydown", escListener);
    firstField.current?.focus();

    return () => document.removeEventListener("keydown", escListener);
  }, [escListener]);

  const trapFocus = (e) => {
    const focusable = dialogRef.current.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select'
    );
    const first = focusable[0];
    const last  = focusable[focusable.length - 1];
    if (e.shiftKey && e.target === first) {
      last.focus();
      e.preventDefault();
    }
    if (!e.shiftKey && e.target === last) {
      first.focus();
      e.preventDefault();
    }
  };

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendLiveDemoEmail(formData);  
      setIsSubmitted(true);
    } catch (err) {
      console.error(err);
      alert("Couldn’t book the demo – please try again.");
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
      onClick={(e) => e.target === e.currentTarget && onClose()}
      aria-labelledby="demo-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        ref={dialogRef}
        onKeyDown={(e) => e.key === "Tab" && trapFocus(e)}
       className="relative bg-white rounded-3xl p-0 w-[92%] max-w-lg overflow-hidden shadow-2xl outline-none"
      >
    <div className="bg-gradient-to-br from-[#36369f] via-[#4b4bbd] to-[#2b2b80] p-6 text-white relative overflow-hidden">


  <div className="absolute inset-0 opacity-30">
    <div className="absolute -top-10 -left-10 w-40 h-40 bg-white/20 rounded-full blur-2xl"></div>
  </div>

  <div className="flex justify-between items-center relative z-10">
    <h2 id="demo-title" className="text-xl md:text-2xl font-bold">
      Book Your Live Demo
    </h2>

    <button
      onClick={onClose}
      className="text-white hover:text-red-300"
    >
      <MdCancel className="text-2xl" />
    </button>
  </div>
</div>
<div className="p-6 md:p-8">
        {!isSubmitted ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block mb-1 font-medium" htmlFor="name">
                Name
              </label>
              <input
                ref={firstField}
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder="Your name"
                className="w-full px-4 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#36369f] focus:border-[#36369f] outline-none transition"
              />
            </div>
            

            <div>
              <label className="block mb-1 font-medium" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleChange}
                placeholder="you@example.com"
                className="w-full px-4 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#36369f] focus:border-[#36369f] outline-none transition"
              />
            </div>

            <div>
              <label className="block mb-1 font-medium" htmlFor="date">
                Preferred Date
              </label>
              <input
                id="date"
                name="date"
                type="date"
                required
                value={formData.date}
                onChange={handleChange}
                className="w-full px-4 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#36369f] focus:border-[#36369f] outline-none transition"
              />
            </div>

            {formData.date && (
              <div>
                <label className="block mb-1 font-medium" htmlFor="time">
                  Preferred Time
                </label>
                <input
                  id="time"
                  name="time"
                  type="time"
                  required
                  value={formData.time}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#36369f] focus:border-[#36369f] outline-none transition"
                />
              </div>
              
            )}
            

            <button
              type="submit"
             className="w-full bg-gradient-to-r from-[#36369f] to-[#4b4bbd] hover:scale-105 active:scale-95 text-white py-2.5 rounded-lg font-semibold shadow-md transition-all duration-300"
            >
              Submit
            </button>
          </form>
          
        ) : (
          <div className="text-center py-10" aria-live="polite">
            <span className="inline-block bg-gradient-to-br from-green-400 to-green-600 rounded-full p-5 mb-4 shadow-lg">
              <FaCheck className="text-green-600 text-2xl" aria-label="tick" />
            </span>
            <h3 className="text-xl font-semibold mb-1">
              Thank you for your interest!
            </h3>
            <p className="text-gray-600 mb-6">
              We will send a confirmation to&nbsp;
              <strong>{formData.email}</strong> shortly with the invite.
            </p>
            <button
              onClick={onClose}
              className="bg-gradient-to-r from-[#36369f] to-[#4b4bbd] py-2.5 px-6 rounded-lg hover:scale-105 transition"
            >
              Close
            </button>
          </div>
          
          
        )}
      </div>
    </div>
    </div>
  );
};

export default BookDemoModal;